<template>
	<form-field-wrap
			:field-props="fieldProps"
			:field-value="fieldProps.VALUE"
			:input-focus="inputFocus">
		<vue-select
				:options="options"
				:value="valueSelect"
				:components="components"
				:inputId="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
				@search:focus="labelSwitch('focus')"
				@search:blur="labelSwitch('blur')"
				@search="onSearch"
				@input="onSelectLocation">
			<template slot="no-options">{{labelForSearch}}</template>
			<template slot="option" slot-scope="option">
					<span class="location_list_item">
						{{ option.label }}
					</span>
			</template>
			<template slot="selected-option" slot-scope="option">
				<span class="location_selected" v-html="valueSelect"></span>
			</template>
		</vue-select>
	</form-field-wrap>
</template>
<script>
	export default {
		name: "StoreByLocation",
		props: {
			city: {
				type: [String, Boolean],
				default: ''
			}
		},
		computed: {
			options() {
				let defaultCity = (this.fieldProps.hasOwnProperty('VALUE_LINK_ITEM')
					&& this.fieldProps.VALUE_LINK_ITEM
					&& this.fieldProps.VALUE_LINK_ITEM.hasOwnProperty('CITY')
					&& this.fieldProps.VALUE_LINK_ITEM.CITY.length > 0) ? this.fieldProps.VALUE_LINK_ITEM.CITY : '';

				let curCity = (this.city && this.city.length > 0) ? this.city : defaultCity;

				let allOptions = this.fieldProps.ITEMS ? this.fieldProps.ITEMS : this.result.LOCATION;
				if (!curCity || curCity.length === 0) {
					return allOptions;
				}

				let options = [];
				for (let i in this.fieldProps.ITEMS) {
					let option = this.fieldProps.ITEMS[i];
					if (option.hasOwnProperty('CITY') && option.CITY && option.CITY === curCity) {
						options.push(option);
					}
				}

				if (options.length === 0) {
					options = allOptions;
				}

				return options;
			},
		},
	};
</script>